const API_URL = process.env.REACT_APP_API_URL;
const AREA_SUBSCRIPTION = API_URL + "/Subscription/";

export const USERS = API_URL + "/user";
export const STOREADMIN_GETUSER = USERS + "/StoreAdminGet";
export const SUPER_ADMIN_UPDATE_USER = API_URL + "/user/SuperAdminUpdateUserInfo?id=";
export const TOOLS_AND_LIB_UPDATE_USER = API_URL + "/user/ToolsAndLibAdminUpdateUserInfo?id=";
export const EXPORT_ALL_USERS = API_URL + "/user/ExportAll";

export const ORGANIZATIONS = API_URL + "/Organization";
export const GET_ALL_ORGANIZATIONS = ORGANIZATIONS + "/GetOrganizationWithDetails";
export const STOREADMIN_GETORG = ORGANIZATIONS + "/StoreAdminGet";
export const UPDATE_ORGANIZATION = ORGANIZATIONS + "/update?id=";
export const COUNTRIES = ORGANIZATIONS + "/countries";
export const ORGANIZATIONNAMES = ORGANIZATIONS + "/names";
export const EXPORT_ALL_ORGANIZATIONS = ORGANIZATIONS + "/ExportAll";

export const ANNOUNCEMENTS =
  API_URL + "/announcement/adminGet?state={0}&skipCount={1}";
export const UPDATE_ANNOUNCEMENTS = API_URL + "/announcement/update?id=";
export const DELETE_ANNOUNCEMENTS = API_URL + "/announcement/delete?id=";
export const CREATE_ANNOUNCEMENT = API_URL + "/announcement/create";

export const ACCESS_REQUEST_USERS = API_URL + "/accessrequest/user";
export const ACCESS_REQUEST_ORGANIZATION =
  API_URL + "/accessrequest/Organization";
export const APPROVE_ORGANIZATION =
  API_URL + "/accessrequest/approve/Organization";
export const APPROVE_USER = API_URL + "/accessrequest/approve/User";

export const ORDER_SEARCH = AREA_SUBSCRIPTION + "order/search";
export const ORDER_GET = AREA_SUBSCRIPTION + "order/get/";
export const ORDER_UPDATE = AREA_SUBSCRIPTION + "order/update";

export const SUBSCRIPTIONS_GETALL = AREA_SUBSCRIPTION + "OrganizationProductSubscription/Admin/GetAll"
export const SUBSCRIPTIONS_GET = AREA_SUBSCRIPTION + "OrganizationProductSubscription/Admin/Get/"
export const SUBSCRIPTIONS_CANCEL = AREA_SUBSCRIPTION + "OrganizationProductSubscription/Admin/Cancel/"